import React, { useEffect, useRef, useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Link, useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';

const Login = () => {

    const toast = useRef(null)

    const [showPassword, setShowPassword] = useState(false);

    const schema = yup.object({
        email: yup.string().required("Email is required").email("Enter a valid email address"),
        password: yup.string().required("Password is required")
    });

    const navigate = useNavigate()

    const { register, handleSubmit, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    useEffect(() => {
        if (localStorage.getItem('token')) {
            navigate('/')
        }
    }, [navigate])

    const onSubmit = (data) => {
        ApiHelper.post(API_ENDPOINTS.LOGIN, data).then((res) => {
            if (res.status === 200) {
                localStorage.setItem('token', res.data.data.token)
                localStorage.setItem('userName', res.data.data.name)
                localStorage.setItem('userType', res.data.data.userType)
                navigate('/')
            }
        }).catch((errors) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: errors.response.data.message, life: 3000 })
        })
    };

    return (
        <>
            <Toast ref={toast} />
            <div class="container-xxl">
                <div class="authentication-wrapper authentication-basic container-p-y">
                    <div class="authentication-inner">
                        <div class="card">
                            <div class="card-body">
                                {/* <!-- Logo --> */}
                                <div class="app-brand justify-content-center">
                                    <Link to="/" class="app-brand-link gap-2">
                                        <span class="app-brand-logo demo">
                                            <img src="/img/logo-light.png" width="200px" />
                                        </span>
                                    </Link>
                                </div>
                                {/* <!-- /Logo --> */}
                                <h4 class="mb-2">Welcome to Tajurba Learning! 👋</h4>
                                <p class="mb-4">Please sign-in to your account</p>

                                <form className="mb-3" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label"> Email address </label>
                                        <input type="email" className="form-control" id="email" placeholder="Enter your email address" {...register("email")} />
                                        {errors.email && (<small className="text-danger"> {errors.email.message} </small>)}
                                    </div>
                                    <div className="mb-1 form-password-toggle">
                                        <label htmlFor="password" className="form-label"> Password </label>
                                        <div className="input-group">
                                            <input type={showPassword ? "text" : "password"} className="form-control" id="password" placeholder="********" {...register("password")} />
                                            <button type="button" className="btn btn-outline-secondary" onClick={() => setShowPassword(!showPassword)}>
                                                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                                            </button>
                                        </div>
                                        <div class="d-flex justify-content-end mt-1">
                                            <Link to="/forgot-password"> <small> Forgot Password? </small> </Link>
                                        </div>
                                        {errors.password && (<small className="text-danger"> {errors.password.message} </small>)}
                                    </div>
                                    <div className="mb-3">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" id="remember-me" {...register("rememberMe")} />
                                            <label className="form-check-label" htmlFor="remember-me" > Remember Me </label>
                                        </div>
                                    </div>
                                    <button className="btn btn-primary d-grid w-100" type="submit" > Sign In </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Login
